import { Expose } from 'class-transformer';
import { Model } from './model';

export class SignedMediaURL extends Model {
  @Expose() fileUrl: string;
  @Expose() uploadURL: string;
}
